import { Dispatch } from 'react';
import config from '../config.json';
import { ITeamRequestState, saveRequestStatus, TeamRequestAction } from '.';
import { SuccessIcon, useDocumentTitle } from '../common';
import { TeamRequest } from './TeamRequest';

export function TeamRequestContainer({
  teamRequestState,
  dispatchTeamRequest,
}: {
  teamRequestState: ITeamRequestState;
  dispatchTeamRequest: Dispatch<TeamRequestAction>;
}) {
  useDocumentTitle({ title: 'Team New Requests' });

  return saveRequestStatus(teamRequestState) === true ? (
    <span>
      <SuccessIcon /> {config.requestSubmitSuccess}
    </span>
  ) : (
    <>
      <TeamRequest
        teamRequestState={teamRequestState}
        dispatchTeamRequest={dispatchTeamRequest}
      />
      {/* <pre>{JSON.stringify(teamRequestState, null, 2)}</pre> */}
    </>
  );
}
